import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import '../../css/pestanas.css';

/**
 * Pestañas accesibles: rol tablist real y navegación con flechas, además del
 * contador de cambios pendientes de cada una.
 */
const Pestanas = ({ pestanas, activa, onCambiar, etiqueta }) => {
  const { t } = useTranslation();
  const refs = useRef({});

  const alPulsarTecla = (e, indice) => {
    const teclas = { ArrowRight: 1, ArrowLeft: -1, Home: 'inicio', End: 'fin' };
    const movimiento = teclas[e.key];
    if (movimiento === undefined) return;

    e.preventDefault();
    let destino;
    if (movimiento === 'inicio') destino = 0;
    else if (movimiento === 'fin') destino = pestanas.length - 1;
    else destino = (indice + movimiento + pestanas.length) % pestanas.length;

    const siguiente = pestanas[destino];
    onCambiar(siguiente.id);
    refs.current[siguiente.id]?.focus();
  };

  return (
    <div className="pu-tabs" role="tablist" aria-label={etiqueta || t('perfilUsuario.seccionesPerfil')}>
      {pestanas.map((pestana, indice) => {
        const seleccionada = activa === pestana.id;
        const Icono = pestana.icono;
        return (
          <button
            key={pestana.id}
            type="button"
            role="tab"
            id={`tab-${pestana.id}`}
            aria-selected={seleccionada}
            aria-controls={`panel-${pestana.id}`}
            tabIndex={seleccionada ? 0 : -1}
            ref={(el) => { refs.current[pestana.id] = el; }}
            className={seleccionada ? 'pu-tab activo' : 'pu-tab'}
            onClick={() => onCambiar(pestana.id)}
            onKeyDown={(e) => alPulsarTecla(e, indice)}
          >
            {Icono && <Icono />}
            {/* data-texto reserva el ancho en negrita: al activarse la pestaña
                no engorda y el resto no se desplaza */}
            <span className="pu-tab-label" data-texto={pestana.label}>{pestana.label}</span>
            {pestana.pendientes > 0 && (
              <span className="pu-tab-badge" title={t('perfilUsuario.cambiosSinGuardarTitle')}>{pestana.pendientes}</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default Pestanas;
